import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "modal-header-section" }
const _hoisted_2 = {
  key: 1,
  class: "modal-header-title"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.isMobile)
      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
          key: 0,
          size: "lg",
          icon: ['fas', 'arrow-left'],
          onClick: _ctx.close
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true),
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.title), 1))
      : _createCommentVNode("", true),
    (!_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, [
          _createVNode(_component_font_awesome_icon, {
            size: "lg",
            icon: ['fas', 'fa-times']
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}